import { useEffect, useState } from "react";
import { fetchSources, type SourceInfo } from "../api.js";

/** Event the SourceTree fires to load a query into the /_data console. */
export const DATA_INSERT_EVENT = "dw-data-insert";

/**
 * Left-sidebar tree for the /_data console: each registered source is a
 * "directory", its tables are "files". Clicking a table loads a starter query
 * into the console (via a window event the DataView listens for). Replaces the
 * file tree on /_data only.
 */
export function SourceTree() {
  const [sources, setSources] = useState<SourceInfo[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchSources()
      .then(setSources)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  const pick = (src: SourceInfo, table: string): void => {
    const sql = `-- @source: ${src.id}\nselect * from ${table} limit 100;`;
    window.dispatchEvent(new CustomEvent(DATA_INSERT_EVENT, { detail: sql }));
  };

  return (
    <nav className="dw-filetree dw-sourcetree">
      {error && <pre className="dw-error">{error}</pre>}
      {!sources && !error && <p className="dw-filetree-empty">Loading…</p>}
      {sources?.map((src) => (
        <details key={src.id} open>
          <summary>{src.label}</summary>
          {src.error ? (
            <p className="dw-muted dw-source-err">{src.error}</p>
          ) : src.tables.length === 0 ? (
            <p className="dw-muted dw-source-err">no tables</p>
          ) : (
            <ul>
              {src.tables.map((t) => (
                <li key={t}>
                  <button
                    type="button"
                    className="dw-tree-file dw-source-table"
                    onClick={() => pick(src, t)}
                    title={`select * from ${t}`}
                  >
                    {t}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </details>
      ))}
    </nav>
  );
}
